<template>
  <!-- 로그인 모달 -->
  <v-dialog
    v-model="modal.show"
    max-width="721"
  >
    <v-card class="find-room-modal">
      <v-layout class="pa-3" align-center justify-space-between row>
        <v-flex class="grow">
          <!--<v-icon size="28" class="icon" style="color:#303030;">feedback</v-icon> --><span class="ml-2" style="font-size: 23px; color:#303030; font-weight: 500; line-height: 1;">{{(form.item_no === 0) ? '알려줘, 하우스북!' : `[${form.item_no}]번 매물 상담`}}</span>
        </v-flex>
        <v-flex class="shrink">
          <div class="btn-close" @click="modal.show = false"><v-icon>close</v-icon></div>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <v-layout justify-space-between row>
        <!-- 업체정보 -->
        <v-flex class="info-area">
          <v-layout class="column">
            <!-- 지도 -->
            <v-flex class="customer-line">
              <v-layout justify-center column>
                <v-flex>
                  <v-layout row>
                    <v-flex class="shrink">
                      <div class="profile-img">
                        <img :src="`${$utile.getStaticUrl()}/logo-profile.svg`" >
                      </div>
                    </v-flex>
                    <v-flex class="grow pl-3 pt-1">
                      <div class="customer-tel"><v-icon>phone</v-icon> {{config.company.customerNumber}}</div>
                      <div class="customer-teltime">{{config.company.customerTime}}</div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex class="info-text">
                  일일이 방찾기 지치시죠?<br>
                  <span class="point">전화 한번이면! 한방에 딱 맞는 방을 찾아드립니다.</span>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-divider></v-divider>
            <v-flex class="biz-line">
              <v-layout justify-center column>
                <div class="biz-name">{{config.company.name}}</div>
                <div class="biz-addr" v-html="config.company.addr"></div>
                <div class="biz-owner">대표자 : {{config.company.owner}}</div>
              </v-layout>
            </v-flex>
            <v-flex>
              <div class="mini-map">
                <mini-map ref="minimap2"
                          :appKey="map.appKey"

                          :center="map.center"
                          :level="map.level"
                          :mapTypeId.sync="map.mapTypeId"
                          :libraries="map.libraries"

                          @load="onLoad"
                          @zoom_start="onMapEvent('zoom_start', $event)"
                          @zoom_changed="onMapEvent('zoom_changed', $event)"
                          @click="onMapEvent('click', $event)"
                          @dblclick="onMapEvent('dblclick', $event)"
                          @rightclick="onMapEvent('rightclick', $event)"
                          @dragstart="onMapEvent('dragstart', $event)"
                          @dragend="onMapEvent('dragend', $event)"
                          @idle="onMapEvent('idle', $event)"
                          @maptypeid_changed="onMapEvent('maptypeid_changed', $event)"

                          style="position:relative; height: 100%;">
                </mini-map>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <div class="height-divider">
        </div>
        <!-- 상담폼 -->
        <v-flex class="form-area">
          <v-form ref="find_room_form"  class="row wrap" lazy-validation>
            <v-flex class="login-from">
              <v-layout column wrap>
                <v-flex>
                  <v-text-field
                    v-model="form.name"
                    label="성함"
                    :rules="rules.name"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    v-model="form.hp"
                    label="연락처"
                    mask="###-####-####"
                    :rules="rules.hp"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    v-model="form.time"
                    label="상담희망시간대"
                    :rules="rules.time"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-textarea
                    v-model="form.memo"
                    name="input-7-1"
                    label="문의내용"
                    rows="5"
                    counter="50"
                    :rules="rules.memo"
                    box
                  ></v-textarea>
                </v-flex>
                <v-flex>
                  <v-checkbox
                    v-model="form.approval"
                    :rules="[v => !!v || '']"
                    label=""
                    color="title_color"
                  >
                    <template slot="append"><span style="color: rgba(0,0,0,.54) !important; white-space: nowrap;"><a href="/bbs/content.php?co_id=privacy" target="_blank">개인정보처리방침</a>, <a href="/bbs/content.php?co_id=provision" target="_blank">이용약관</a> 동의</span></template>
                  </v-checkbox>
                </v-flex>
                <v-flex>
                  <v-btn block color="title_dark1" style="height: 46px;"  @click="submitForm">
                    <span style="color:#fff; font-size: 16px;">문의하기</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-form>
        </v-flex>
      </v-layout>
    </v-card>
    <!-- // -->
  </v-dialog>
</template>

<script>
import Utile from '@/utile/utile'
import EventBus from '@/utile/eventBus'
import { mapState, mapActions } from 'vuex'

import MiniMap from '@/components/plugin/KakaoMap'

export default {
  name: 'FindRoom',
  components: {
    MiniMap
  },
  data: () => ({
    // 맵
    map: {
      appKey: '',
      center: { lat: 37.4803073, lng: 126.9328443 },
      level: 5, // 기본 3
      mapTypeId: MiniMap.MapTypeId.NORMAL,
      libraries: [ 'services' ],
      mapObject: null,
      geocoder: null,
      roadviewArea: false,
      polygon: null
    },
    modal: {
      show: false
    },
    form: {
      item_no: 0,
      name: '',
      hp: '',
      time: '',
      memo: '',
      approval: false
    },
    rules: {
      name: [
        v => !!v || '성함을 입력해주세요.'
      ],
      hp: [
        v => !!v || '연락처를 입력해주세요.'
      ],
      time: [
        v => !!v || '상담희망 시간대를 입력해주세요.',
        v => (v && v.length <= 20) || '내용이 너무 많습니다.'
      ],
      memo: [
        v => !!v || '문의 내용을 입력해주세요.',
        v => (v && v.length <= 50) || '문의내용이 너무 많습니다.'
      ]
    }
  }),
  computed: {
    ...mapState({
      manager: state => state.manager,
      auth: state => state.auth,
      config: state => state.config
    })
  },
  created () {
    this.map.appKey = this.config.kakaRestApiAppKey
  },
  mounted () {
    EventBus.$on('findRoom', (no) => {
      // 초기화
      this.form.name = ''
      this.form.hp = ''
      this.form.time = ''
      this.form.memo = ''
      // 로그인 상태하면
      if (this.auth.isAuth) {
        this.form.name = this.auth.name
        if (this.auth.hp) {
          this.form.hp = this.auth.hp
        }
      }
      if (no === 0) { // 방찾아주세요
        if (Utile.isMobile()) { // 모바일
          const type = 'inquirySMS'
          this.inquiry({ type })
          // let sms = this.getSmsStr(`sms:${this.manager.m_hp}?body=${this.manager.m_name} ${this.manager.m_jobGrade}님~! 저에게 딱 맞는 방을 찾아주세요!`)
          let sms = this.getSmsStr(`sms:${this.manager.m_hp}?body=` + encodeURIComponent(`[하우스북]\n저에게 딱 맞는 방을 찾아주세요!\n\n1.찾으시는위치:\n2.이사날짜:\n3.보증금/월세:\n4.주차,반려견 유/무:\n5.그외 남기실말씀:`))
          document.location.href = sms
        } else { // 데스크탑
          this.form.item_no = no
          this.modal.show = true
          this.$refs.minimap2.init()
        }
      } else { // 매물지정
        if (Utile.isMobile()) { // 모바일
          const type = 'inquirySMS'
          this.inquiry({ type })
          // let sms = this.getSmsStr(`sms:${this.manager.m_hp}?body=${this.manager.m_name} ${this.manager.m_jobGrade}님~! [${no}]번 매물 상담해주세요!`)
          let sms = this.getSmsStr(`sms:${this.manager.m_hp}?body=` + encodeURIComponent(`[하우스북]\n이 방 상담해주세요!\n\n매물번호 : ${no}\n링크 : https://housebook.kr/#/map?no=r${no}`))
          document.location.href = sms
        } else { // 데스크탑
          this.form.item_no = no
          this.modal.show = true
          this.$refs.minimap2.init()
        }
      }
    })
    // 매니저 고정 임시주석
    /*
    const mid = localStorage.getItem('manager_id')
    if (mid) {
      this.manager.m_id = mid
    }
    */
    // 매니저 배정
    // this.updateMamagerInfo()
    this.initManagerCheckTimer()
  },
  methods: {
    ...mapActions({
      updateMamagerInfo: 'manager/update',
      initManagerCheckTimer: 'manager/initManagerCheckTimer',
      inquiry: 'manager/inquiry'
    }),
    /* 맵 온로드 */
    onLoad (map) {
      this.map.mapObject = map
      this.$refs.minimap2.addressSearch(this.config.company.addr)
    },
    /* 맵 이벤트 */
    onMapEvent (event, params) {
      //
    },
    submitForm () {
      if (this.$refs.find_room_form.validate()) { // 룰에 어긋나지 않는다면
        this.modal.show = false
        // {item_no: this.form.item_no, name: this.form.name, hp: this.form.hp, time: this.form.time, memo: this.form.memo}
        const type = 'inquiry'
        const form = {item_no: this.form.item_no, name: this.form.name, hp: this.form.hp, time: this.form.time, memo: this.form.memo}
        this.inquiry({ type, form })
      }
    },
    getSmsStr (str) {
      if (Utile.isiPhone()) {
        str = str.replace('?', '&')
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/modal/FindRoom.vue